// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .card {
  border-radius: var(--CardCorner, 0rem);
  border: 1px solid var(--gray-300);
  transition: var(--fx1);
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
  box-shadow: none;
}
:host .card figure {
  aspect-ratio: 1.5;
  width: 100%;
  overflow: hidden;
  margin: 0;
}
:host .card figure img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transition: var(--fx1);
}
:host .card .content {
  display: flex;
  padding: var(--spacer4);
  flex-direction: column;
  font-size: 0.9rem;
  gap: var(--spacer3);
  flex: 1 1 auto;
}
:host .card .content .description {
  flex: 1 1 auto;
}
:host .card .content .titre {
  display: flex;
  flex-direction: column;
}
:host .card .content .titre h2 {
  color: var(--Black, #000);
  font-family: var(--font-family);
  font-size: 1.7em;
  font-weight: 600;
  line-height: 1.1em;
  margin: 0;
}
:host .card .content footer {
  font-size: 0.8rem;
  text-align: center;
}
:host .card .content footer ul {
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  gap: var(--spacer2);
  margin: 0;
  padding: 0;
}
:host .card .content footer ul li {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--spacer2);
  flex: 1 1 auto;
  border-right: 1px solid var(--gray-400);
}
:host .card .content footer ul li .data {
  min-height: 1.5rem;
}
:host .card .content footer ul li:last-child {
  border-right: none;
}
:host .card:hover {
  border-color: var(--primary-color);
  box-shadow: inset 0 0 0 1px var(--primary-color);
}
:host .card:hover figure img {
  scale: 1.1;
}

.card-image img {
  object-fit: cover;
}

.card-image img.loaded {
  display: block;
}

.imgStyleVig {
  height: 105%;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
